import { store } from '../store';
import {
    SAVE_RELATIONSHIP_NAME,
    RESET_RELATIONSHIP_NAME,
    INITIATE_QUESTIONNAIRE_DYNAMIC_LANDING_SUCCESS,
    INITIATE_QUESTIONNAIRE_DYNAMIC_LANDING_FAILURE,
    INITIATE_QUESTIONNAIRE_DYNAMIC_LANDING,
    SEND_BPS_QUESTION,
    SEND_BPS_QUESTION_SUCCESS,
    SEND_BPS_QUESTION_FAILURE,
    RESET_SESSIONID,
    RELATIONSHIP_NAMEFIELD_ERROR,
    UPDATE_PAGE_FORM_FIELD,
    INITIATE_QUESTIONNAIRE_BUSINESSTYPE,
    UPDATE_TO_PREVIOUS_PAGE,
    UPDATE_APP_PAGE_ANSWERS,
    SET_BACK_BUTTON_FLAG,
    RESET_BANKER_QUESTIONNAIRE,
} from '../../constants/dynamicLanding';

import {
    dynamicClient as graphQlClient,
    START_BPS_QUESTIONNAIRE,
    SEND_BPS_QUESTION_ANSWER,
} from '../../graphql';
import { resetVisibleQuestions, updateVisibleQuestions } from './app';
import { getVisibleQuestions } from '../../utils';

export const resetBankerQuestionnaire = () => ({
    type: RESET_BANKER_QUESTIONNAIRE,
    error: null,
    isLoading: false,
});
export const updateBusinessType = (selectedOptions) => ({
    type: INITIATE_QUESTIONNAIRE_BUSINESSTYPE,
    error: null,
    businessType: selectedOptions,
    isLoading: false,
});
export const saveRelationshipName = (payload) => ({
    type: SAVE_RELATIONSHIP_NAME,
    payload,
});
export const resetRelationshipName = () => ({
    type: RESET_RELATIONSHIP_NAME,
});
export const resetSessionID = () => ({
    type: RESET_SESSIONID,
});

export const sendGoalQuestionSuccess = (payload) => ({
    type: SEND_BPS_QUESTION_SUCCESS,
    payload,
    error: null,
    isLoading: false,
});

export const sendGoalQuestionFailure = (error) => ({
    type: SEND_BPS_QUESTION_FAILURE,
    error,
    isLoading: false,
});

export const initiateQuestionnaireDynamicLandingSuccess = (
    payload,
) => ({
    type: INITIATE_QUESTIONNAIRE_DYNAMIC_LANDING_SUCCESS,
    payload,
    error: null,
    isLoading: false,
});

export const updateFormField = (
    field,
    input,
    allQuestions,
    dynamicFormFields,
) => ({
    type: UPDATE_PAGE_FORM_FIELD,
    isLoading: false,
    elementID: field,
    selectedItem: input.inputValue,
    allQuestions,
    dynamicFormFields,
});

export const backToLastQuestion = (
    activeQuestionID,
    dataArchive,
) => ({
    type: UPDATE_TO_PREVIOUS_PAGE,
    activeQuestionID,
    dataArchive,
});

export const initiateQuestionnaireDynamicLandingFailure = (
    error,
) => ({
    type: INITIATE_QUESTIONNAIRE_DYNAMIC_LANDING_FAILURE,
    error,
    isLoading: false,
});
export const RelationshipNameFieldError = (formFields) => ({
    type: RELATIONSHIP_NAMEFIELD_ERROR,
    formFields,
    isLoading: false,
});
export const setBackButton = (flag) => ({
    type: SET_BACK_BUTTON_FLAG,
    flag,
    isLoading: false,
});
export const updateAppPageAnswers = (
    questionID,
    visibleQuestions,
    answerID,
    unsavedAnswerContainer,
) => ({
    type: UPDATE_APP_PAGE_ANSWERS,
    visibleQuestions,
    questionID,
    answerID,
    unsavedAnswerContainer,
    isLoading: false,
});
export const initiateQuestionnaireDynamicLanding =
    (productID, callErrorScreen) => async (dispatch) => {
        try {
            dispatch({
                type: INITIATE_QUESTIONNAIRE_DYNAMIC_LANDING,
                isLoading: true,
            });

            await graphQlClient
                .mutate({
                    mutation: START_BPS_QUESTIONNAIRE,
                    variables: { productID },
                    fetchPolicy: 'no-cache',
                })
                .then((data) => {
                    const {
                        data: {
                            startOver: {
                                sessionId,
                                nextQuestionnaire,
                            },
                        },
                    } = data;
                    const activeQuestionId =
                        nextQuestionnaire?.[0]?.id ?? '';

                    const questionnaire = {
                        sessionID: sessionId,
                        fullResponse: data,
                        activeQuestionID: activeQuestionId,
                        questionnaire: nextQuestionnaire[0],
                        nestedQuestionaire: nextQuestionnaire[1],
                        allQuestionaire: nextQuestionnaire,
                    };

                    dispatch(
                        initiateQuestionnaireDynamicLandingSuccess(
                            questionnaire,
                        ),
                    );
                });
        } catch (err) {
            if (callErrorScreen) {
                callErrorScreen();
            }
            dispatch(initiateQuestionnaireDynamicLandingFailure(err));
        }
    };
export const sendBPSQuestion = (payload) => async (dispatch) => {
    try {
        dispatch({ type: SEND_BPS_QUESTION, isLoading: true });
        const {
            productID,
            sessionID,
            customerID,
            questionID,
            answerInfo,
            selectedQuestionnaire,
            answerContainer,
        } = payload;

        const answerID = answerInfo;
        await graphQlClient
            .mutate({
                mutation: SEND_BPS_QUESTION_ANSWER,
                variables: {
                    productID,
                    sessionID,
                    customerID,
                    selectedQuestionnaire,
                },
                fetchPolicy: 'no-cache',
            })
            .then((data) => {
                const {
                    data: {
                        pullQuestionnaire: {
                            sessionId,
                            nextQuestionnaire,
                        },
                    },
                } = data;
                const activeQuestionId =
                    nextQuestionnaire?.[0]?.id ?? '';

                const {
                    dynamicLandingReducer: {
                        questionnaire: { metaData, answers },
                    },
                } = store.getState();
                const questionnaire = {
                    sessionID: sessionId,
                    questionnaire: nextQuestionnaire?.[0],
                    allQuestionaire: nextQuestionnaire,
                    questionState: {
                        id: questionID,
                        currentAnswer: answerID,
                        answers,
                        metaData,
                    },
                    fullResponse: data,
                    activeQuestionID: activeQuestionId,
                };
                dispatch(resetVisibleQuestions());
                const visibleQuestions = getVisibleQuestions(
                    answerContainer,
                    activeQuestionId,
                );
                dispatch(updateVisibleQuestions(visibleQuestions));
                dispatch(sendGoalQuestionSuccess(questionnaire));
            });
    } catch (err) {
        dispatch(sendGoalQuestionFailure(err));
    }
};
